import React from 'react';

interface QuantitySelectorInterface {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
}

const QuantitySelector = ({
  quantity = 0,
  onDecrease,
  onIncrease
}: QuantitySelectorInterface) => {
  return (
    <>
      <div
        style={styles.container}
      >
        <button
          style={styles.button}
          onClick={() => onDecrease()}
        >
          -
        </button>
        <p
           style={styles.quantity}
        >
          {quantity}
        </p>
        
        <button
          style={styles.button}
          onClick={() => onIncrease()}
        >
          +
        </button>
      </div>
    </>
  )
}

export default QuantitySelector;

const styles: {[key: string]: React.CSSProperties} =  {
  container: {
    // border: '1px solid red',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    background: 'transparent',
    border: 'none',
    fontFamily: 'Poppins-SemiBold',
    fontSize: `1rem`,
    lineHeight: `1rem`,
    color: '#E5605E'
  },
  quantity: {
    fontFamily: 'Poppins-Light',
    fontSize: `0.8rem`,
    lineHeight: `0.8rem`,
    margin: '0rem 0.7rem', 
  }
}